import { Banner } from './banners';

export type Base64 = string;
export type SectionId = 'pharmacy-strength-medicines' | 'all-medicines' | 'prescription' | 'download-mobile-app' | 'pharmacy-finder' | 'edition-banners' | 'clinic' | 'pharmacy-services' | 'healthera-navigation' | 'pharmacy-shop' | 'hero-block' | 'learn-more';

export type WebsiteMeta = {
  title?: string;
  description?: string;
  'og:title'?: string;
  'og:description'?: string;
  'og:image'?: string;
  image?: Base64;
};

export type AboutUs = {
  enabled: boolean;
  title: string;
  description: string;
  image_url: string;
  image: Base64;
};

export type FooterCustomLink = {
  title: string;
  link: string;
  id: string;
};

export type ApiReadyFooterCustomLink = Omit<FooterCustomLink, 'id'>;

export type HeroBlock = {
  headline?: string;
  subtitle?: string;
  image_urls?: string[];
  images?: (Base64 | null)[];
  learn_more_intro?: string;
  cta_text?: string;
  cta_link?: string;
};

export type ColorsSettings = {
  primary?: string;
  light_primary?: string;
  secondary?: string;
  tertiary?: string;
};

export type Branding = {
  colors?: ColorsSettings;
  display_powered_by?: boolean;
};

export enum OnboardingJourney {
  PHARMACY_SELECT = 'pharmacy_select',
  DELIVERY_COLLECTION = 'delivery_collection',
  MARKETPLACE = 'marketplace',
}

export enum PatientCommunicationChannel {
  HEALTHERA = 'healthera',
  PARTNER = 'external',
}

export type PrivatePrescriptionsJourney = {
  collection?: boolean,
  delivery?: boolean,
  classic_mode_collection?: boolean,
}

export type ContactUs = {
  enabled?: boolean;
  contact_name?: string;
  contact_address?: string;
  email?: string;
  phone_number?: string;
  contact_hours?: string;
  gphc_number?: string;
  gphc_url?: string;
  display_gphc_logo?: boolean;
  pharmacy_superintendent_name?: string;
  pharmacy_superintendent_registration_number?: string;
  pharmacy_superintendent_gphc_url?: string;
};

export type Favicon = {
  '16x16': Base64 | string;
  '32x32': Base64 | string;
  '48x48': Base64 | string;
  '192x192': Base64 | string;
}

export type WebsiteConfiguration = {
  deployed?: boolean;
  enabled?: boolean;
  logo_url?: string;
  logo_url_white?: string;
  logo?: Base64;
  logo_white?: Base64;
  favicon?: Partial<Favicon>;
  hero?: HeroBlock;
  branding?: Branding;
  banners?: Banner[];
  domain?: string;
  homepage_url?: string;
  homepage_sections?: SectionId[];
  about_us?: Partial<AboutUs>;
  contact_us?: ContactUs;
  onboarding_journey?: OnboardingJourney;
  private_prescriptions_journey?: PrivatePrescriptionsJourney;
  footer_custom_links?: FooterCustomLink[];
  meta?: WebsiteMeta;
  name?: string;
  pharmacy_required?: boolean;
  pharmacy_required_redirect?: string;
  communication_channel: PatientCommunicationChannel;
};

export type ApiReadyWebsiteConfiguration = {
  enabled?: boolean;
  logo_url?: string;
  logo_url_white?: string;
  favicon?: Partial<Favicon>;
  logo?: Base64;
  logo_white?: Base64;
  hero?: HeroBlock;
  branding?: Branding;
  banners?: Banner[];
  domain?: string;
  homepage_url?: string;
  homepage_sections?: SectionId[];
  about_us?: Partial<AboutUs>;
  contact_us?: ContactUs;
  onboarding_journey?: OnboardingJourney;
  private_prescriptions_journey?: PrivatePrescriptionsJourney;
  footer_custom_links?: ApiReadyFooterCustomLink[];
  meta?: WebsiteMeta;
  name?: string;
};
